import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { PartnerLayout } from '@/pages/partner/layout/PartnerLayout';
import { AppLayoutSkeleton } from '@/layout/AppLayoutSkeleton';
import { requireAuthenticated } from '@/lib/auth/authSnapshot';
import '@/types/router';

export const Route = createFileRoute('/partner')({
  component: PartnerLayoutRoute,
  // Same pending boundary as $slug (see the comment there): no delay, no minimum.
  pendingComponent: AppLayoutSkeleton,
  pendingMs: 0,
  pendingMinMs: 0,
  beforeLoad: () => {
    const auth = requireAuthenticated();

    // Only partner tenants may enter the partner area. Non-partners bounce to
    // the root dispatcher, which redirects them to their correct home.
    if (!auth.isPartner) {
      throw redirect({ to: '/' });
    }

    return {};
  }
});

function PartnerLayoutRoute() {
  return (
    <PartnerLayout>
      <Outlet />
    </PartnerLayout>
  );
}
